import { Component, Input, OnInit } from '@angular/core';
import { AdministrationCheckout, AppointmentSummary, Lookups, Patient, PopupModelReturn, PopupSetupModel, Staff } from '../../../AllTableClasses';
import { PopupNotificationService } from '../../../Services/popup-notification.service';
import { LookupsService } from '../../../Services/lookups.service';
import { MembersService } from '../../../Services/members.service';
import { StaffService } from '../../../Services/staff.service';
import { SchedulerService } from '../../../Services/scheduler.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-checkout-popup',
  templateUrl: './checkout-popup.component.html',
  styleUrl: './checkout-popup.component.scss'
})
export class CheckoutPopupComponent implements OnInit {

  private destroy$ = new Subject<void>();


  popup: PopupSetupModel | null = null;
  popupReturn: PopupModelReturn = new PopupModelReturn();

  public submitted: boolean = false;

  @Input() Data!: AppointmentSummary;
  public appointment: AppointmentSummary = new AppointmentSummary();
  public appointmentCheckout: AdministrationCheckout = new AdministrationCheckout();
  public provinces: Array<Lookups> = new Array<Lookups>();
  public genders: Array<Lookups> = new Array<Lookups>();
  public titles: Array<Lookups> = new Array<Lookups>();
  public statusList: Array<Lookups> = new Array<Lookups>();
  public patientGroups: Array<Lookups> = new Array<Lookups>();

  public contactSelection!: string;
  public patient: Patient = new Patient();

  public ChargeDropdownOpen: boolean = false;
  public StaffDropdownOpen: boolean = false;

  public staffList: Array<Staff> = new Array<Staff>();
  public selectedStaff!: string;
  public selectedCharge!: string;

  public hearingOutcomes = [{ outcome: 'NORMAL HEARING' }, { outcome: 'HA CANIDATE' }, { outcome: 'SICK EARS / REFERRAL' }, { outcome: 'EI HA USER / NEEDS NEW HA' }, { outcome: 'EI HA USER / ADJUSTMENTS' }, { outcome: 'OTHER OUTCOME' }];
  public finalHAOutcomes = [{ outcome: 'HA SOLD & FITTED' }, { outcome: 'TRIAL FITTED' }, { outcome: 'DEMO TO HA SOLD & FITTED' }, { outcome: 'TRIAL TO HA SOLD & FITTED' }, { outcome: 'TRIAL / DEMO NOT TAKEN' }, { outcome: 'NO HA FITTED' }, { outcome: 'ONGOING TRIAL ' }];
  public futureActions = [{ outcome: 'ANNUAL TESTING' }, { outcome: 'LIFESTYLE PRODUCT FITTING' }, { outcome: 'FOLLOW UP' }];

  constructor(
    private popupNotificationService: PopupNotificationService,
    private membersService: MembersService,
    private lookupService: LookupsService,
    private staffService: StaffService,
    private schedulerService: SchedulerService,

  ) { }

  ngOnInit(): void {
    this.popupNotificationService.checkoutNotification$.pipe(takeUntil(this.destroy$)).subscribe((popup: PopupSetupModel | null) => {
      this.popup = popup;
      if (this.popup) {
        this.StaffGet();
        this.appointment = new AppointmentSummary();
        this.submitted = false;
        if (popup?.Data) {
          this.appointment = popup.Data;
          this.MemberGetByGuid(this.appointment.PatientGuid);
          if (popup?.PopupAction == 'Administration') {
            //this.InvoiceTypeGet();
            this.AdministrationCheckoutGetByAppointmentID();
          }
          if (popup?.PopupAction == 'Audiologist') {
            this.MemberStatusGet();
            this.MemberGroupGet();
            this.AudiologistCheckoutGetByAppointmentID();        
          }
        }
      }
    });
  }

  public MemberStatusGet() {
    this.lookupService.MemberStatusGet((data) => {
      if (data.Success) {
        this.statusList = data.Data;
      }
      else {
        console.log("Error: ", data.UserErrorMessage);
      }
    }, (error) => { });
  }
  public MemberGroupGet() {
    this.lookupService.MemberGroupGet((data) => {
      if (data.Success) {
        this.patientGroups = data.Data;
      }
      else {
        console.log("Error: ", data.UserErrorMessage);
      }
    }, (error) => { });
  }

  public StaffGet() {
    this.staffService.StaffSearch("", false, null, null, null, (data) => {
      if (data.Success) {
        this.staffList = data.Data;
      }
      else {
        console.log("Error: ", data.UserErrorMessage);
      }
    }, (error) => { });
  }

  public AdministrationCheckoutGetByAppointmentID() {
    this.schedulerService.AdministrationCheckoutGetByAppointmentID(this.appointment.ID, (data) => {
      if (data.Success) {
        this.appointmentCheckout = data.Data;
      }
      else {

      }
    }, (error) => { });
  }
  public AudiologistCheckoutGetByAppointmentID() {
    this.schedulerService.AudiologistCheckoutGetByAppointmentID(this.appointment.ID, (data) => {
      if (data.Success) {
        this.appointmentCheckout = data.Data;
      }
      else {
        console.log("Error: ", data.UserErrorMessage);
      }
    }, (error) => { });
  }


  public MemberGetByGuid(PatientGuid: string) {
    this.membersService.MemberGetByGuid(PatientGuid, (data) => {
      if (data.Success) {
        this.patient = data.Data;
      }
      else {
        console.log("Error: ", data.UserErrorMessage);
      }
    }, (error) => { });
  }


  ButtonClick() {
    if (this.popup?.Button) {
      this.submitted = true;
      this.popupReturn.Result = this.popup.Button.Result;
      this.appointmentCheckout.AppointmentID = this.appointment.ID;
      this.appointmentCheckout.CheckoutStatus = 'Open';
      if (this.popup?.PopupAction == 'Audiologist') {
        this.appointmentCheckout.PatientStatus = this.patient.Status;
        this.popupReturn.Data = { appointmentCheckout: this.appointmentCheckout, patient: this.patient };
      }
      else {
        this.popupReturn.Data = this.appointmentCheckout;

      }
      this.clearPopup();
      this.popupNotificationService.ResolveCheckoutPopup(this.popupReturn);
    }
    this.submitted;
}

  AltButtonClick() {
    if (this.popup?.AltButton) {
      this.popupReturn.Result = this.popup.AltButton.Result;
      this.clearPopup();
      this.popupNotificationService.ResolveCheckoutPopup(this.popupReturn);
    }
  }

  PopupEvent(event: string) {
    if (event === 'close') {
      this.popupReturn.Result = 'close';
      this.clearPopup();
      this.popupNotificationService.ResolveCheckoutPopup(this.popupReturn);
    }

  }

  clearPopup() {
    this.popup = null;
    this.contactSelection = '';
    this.appointment = new AppointmentSummary();
    this.submitted = false;
  }

  ngOnDestroy(): void {
    // Emit and complete the destroy$ Subject to clean up subscriptions
    this.destroy$.next();
    this.destroy$.complete();
  }
}
